import fieldList from "./acceptedFields.json"

async function sanitizeQueryObject(obj) {
    const sanitizedObj = {};
    for (const key in obj) {
        if (isValidField(key)) {
            if (typeof obj[key] === "string") {
                sanitizedObj[key] = obj[key].replace(/[^a-zA-Z0-9 ]/g, ""); // Removes special characters
            } else {
                sanitizedObj[key] = obj[key];
            }
        }
    }
    return sanitizedObj;
}


function isValidField(field) {
    return fieldList.includes(field)
}

export const sanitize = {
    sanitizeQueryObject
}